import { ExternalHyperlink, TextRun } from 'docx'

interface Location {
  city?: string
  region?: string
  address?: string
  postalCode?: string
  countryCode?: string
}

export const formatLocation = (location: Location) => {
  const parts: string[] = []

  if (location?.city) parts.push(location.city)
  if (location?.region) parts.push(location.region)
  if (location?.postalCode) parts.push(location.postalCode)
  if (location?.countryCode) parts.push(location.countryCode)

  return parts.join(', ')
}

export const createHyperlink = (text: string, link: string) => {
  return new ExternalHyperlink({
    children: [new TextRun({ text })],
    link,
  })
}
